import axios from 'axios';
import { API_BASE_URL } from './auth';

// IMPORTANT: baseURL must NOT include /api — pages call `${API}/broker/config`
// where API already ends with /api. Setting baseURL=/api caused /api/api/... 404.
axios.defaults.baseURL = API_BASE_URL || undefined;
axios.defaults.withCredentials = true;

let installed = false;

/** Attach Authorization: Bearer <token> to every axios request. */
export function installAxiosAuth() {
  if (installed) return;
  installed = true;

  axios.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers.Authorization) {
        config.headers.Authorization = 'Bearer ' + token;
      }
    }
    return config;
  });

  axios.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err && err.response && err.response.status === 401) {
        console.warn('API 401', err.config && err.config.url);
      }
      return Promise.reject(err);
    }
  );
}
